(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

jQuery(document).ready(function(){
    // Set first tab active by default
    $('.custom-tabs-nav li:first-child').addClass('active');
    $('.custom-tab-panel').hide();
    $('.custom-tab-panel:first').show();

    // Click event for tabs
    $('.custom-tabs-nav li').click(function() {
        // Remove active class from all tabs
        $('.custom-tabs-nav li').removeClass('active');
        // Add active class to the clicked tab
        $(this).addClass('active');

        // Hide all tab panels
        $('.custom-tab-panel').hide();

        // Show the selected tab panel
        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();

        return false; // Prevent default anchor behavior
    });

    $('span.mobile-search').click(function() {
        $('#center-search').toggleClass('show')
        $(this).toggleClass('active')
    });
    
    //tabs end here
    

    // Sort your capacity and psi options (keep your sorting code)
    var selectList = $('select[name="search_capacity"] option');
    selectList.sort(function(a,b){
        a = a.value;
        b = b.value;
        return a-b;
    });
    $('select[name="search_capacity"]').html(selectList);

    var selectList = $('select[name="search_psi"] option');
    selectList.sort(function(a,b){
        a = a.value;
        b = b.value;
        return a-b;
    });
    $('select[name="search_psi"]').html(selectList);

    // --- New filtering logic starts here ---

    // Parse your product data JSON from Liquid
    let products = [];
    try {
      products = JSON.parse(document.getElementById('productData').textContent);
    } catch(e) {
      console.error('Failed to parse product data', e);
    }

    // Build mapping: orientation -> capacity -> set of psi
    let mapping = {};
    products.forEach(p => {
      if(!p.orientation || !p.capacity || !p.psi) return;
      if(!mapping[p.orientation]) mapping[p.orientation] = {};
      if(!mapping[p.orientation][p.capacity]) mapping[p.orientation][p.capacity] = new Set();
      mapping[p.orientation][p.capacity].add(p.psi);
    });

    // Convert Sets to sorted arrays for easy iteration
    Object.keys(mapping).forEach(ori => {
      Object.keys(mapping[ori]).forEach(cap => {
        mapping[ori][cap] = Array.from(mapping[ori][cap]).sort((a,b) => parseFloat(a) - parseFloat(b));
      });
    });

    const $ori = $('select[name="search_ori"]');
    const $cap = $('select[name="search_capacity"]');
    const $psi = $('select[name="search_psi"]');

    // Disable capacity and psi initially
    $cap.prop('disabled', true);
    $psi.prop('disabled', true);

    // Update capacity options on orientation change
    $ori.on('change', function(){
      const ori = $(this).val();
      $cap.empty().append('<option value="">Capacity</option>');
      $psi.empty().append('<option value="">PSI</option>').prop('disabled', true);

      if(ori && mapping[ori]){
        Object.keys(mapping[ori]).sort((a,b) => parseFloat(a) - parseFloat(b)).forEach(cap => {
          $cap.append(`<option value="${cap}">${cap}</option>`);
        });
        $cap.prop('disabled', false);
      } else {
        $cap.prop('disabled', true);
      }
    });

    // Update psi options on capacity change
    $cap.on('change', function(){
      const ori = $ori.val();
      const cap = $(this).val();
      $psi.empty().append('<option value="">PSI</option>');

      if(ori && cap && mapping[ori] && mapping[ori][cap]){
        mapping[ori][cap].forEach(psi => {
          $psi.append(`<option value="${psi}">${psi}</option>`);
        });
        $psi.prop('disabled', false);
      } else {
        $psi.prop('disabled', true);
      }
    });

    // Your existing search button handler (keep unchanged)
    jQuery('body').on('click', '#searchByConfigHeader', function(e){
      e.preventDefault();
      let searchurl = '/collections/all?';
      let search_capacity = $cap.val();
      let search_psi = $psi.val();
      let search_ori = $ori.val();

      if(search_capacity){
        searchurl += 'filter.p.m.custom.capacity=' + encodeURIComponent(search_capacity) + '&';
      }
      if(search_psi){
        searchurl += 'filter.p.m.custom.psi=' + encodeURIComponent(search_psi) + '&';
      }
      if(search_ori){
        searchurl += 'filter.p.m.custom.orientation=' + encodeURIComponent(search_ori);
      }
      searchurl = searchurl.replace(/&$/, '');
      location.href = searchurl;
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-search"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    // Your existing tabs code, sorting, etc. remains unchanged
    // === Tabs functionality ===
    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

    $('#tabs-nav li').click(function () {
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();

      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });

    // Sort your capacity and psi options (keep your sorting code)
    var selectList = $('select[name="search_capacity_home"] option');
    selectList.sort(function (a, b) {
      a = a.value;
      b = b.value;
      return a - b;
    });
    $('select[name="search_capacity_home"]').html(selectList);

    var selectList = $('select[name="search_psi_home"] option');
    selectList.sort(function (a, b) {
      a = a.value;
      b = b.value;
      return a - b;
    });
    $('select[name="search_psi_home"]').html(selectList);

    // --- New filtering logic starts here ---

    // Parse your product data JSON from Liquid
    let products = [];
    try {
      products = JSON.parse(document.getElementById('productData').textContent);
    } catch (e) {
      console.error('Failed to parse product data', e);
    }

    // Build mapping: orientation -> capacity -> set of psi
    let mapping = {};
    products.forEach((p) => {
      if (!p.orientation || !p.capacity || !p.psi) return;
      if (!mapping[p.orientation]) mapping[p.orientation] = {};
      if (!mapping[p.orientation][p.capacity]) mapping[p.orientation][p.capacity] = new Set();
      mapping[p.orientation][p.capacity].add(p.psi);
    });

    // Convert Sets to sorted arrays for easy iteration
    Object.keys(mapping).forEach((ori) => {
      Object.keys(mapping[ori]).forEach((cap) => {
        mapping[ori][cap] = Array.from(mapping[ori][cap]).sort((a, b) => parseFloat(a) - parseFloat(b));
      });
    });

    const $ori = $('select[name="search_ori_home"]');
    const $cap = $('select[name="search_capacity_home"]');
    const $psi = $('select[name="search_psi_home"]');

    // Disable capacity and psi initially
    $cap.prop('disabled', true);
    $psi.prop('disabled', true);

    // Update capacity options on orientation change
    $ori.on('change', function () {
      const ori = $(this).val();
      $cap.empty().append('<option value="">Capacity</option>');
      $psi.empty().append('<option value="">PSI</option>').prop('disabled', true);

      if (ori && mapping[ori]) {
        Object.keys(mapping[ori])
          .sort((a, b) => parseFloat(a) - parseFloat(b))
          .forEach((cap) => {
            $cap.append(`<option value="${cap}">${cap}</option>`);
          });
        $cap.prop('disabled', false);
      } else {
        $cap.prop('disabled', true);
      }
    });

    // Update psi options on capacity change
    $cap.on('change', function () {
      const ori = $ori.val();
      const cap = $(this).val();
      $psi.empty().append('<option value="">PSI</option>');

      if (ori && cap && mapping[ori] && mapping[ori][cap]) {
        mapping[ori][cap].forEach((psi) => {
          $psi.append(`<option value="${psi}">${psi}</option>`);
        });
        $psi.prop('disabled', false);
      } else {
        $psi.prop('disabled', true);
      }
    });

    // Your existing search button handler (keep unchanged)
    jQuery('body').on('click', '#searchByConfig', function (e) {
      e.preventDefault();
      let searchurl = '/collections/all?';
      let search_capacity_home = $cap.val();
      let search_psi_home = $psi.val();
      let search_ori_home = $ori.val();

      if (search_capacity_home) {
        searchurl += 'filter.p.m.custom.capacity=' + encodeURIComponent(search_capacity_home) + '&';
      }
      if (search_psi_home) {
        searchurl += 'filter.p.m.custom.psi=' + encodeURIComponent(search_psi_home) + '&';
      }
      if (search_ori_home) {
        searchurl += 'filter.p.m.custom.orientation=' + encodeURIComponent(search_ori_home);
      }
      searchurl = searchurl.replace(/&$/, '');
      location.href = searchurl;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  $('.cart__items-wrapper, .cart__footer-wrapper').wrapAll('<div class="footerWrapper"><div class="page-width"><div class="footerWrapperInner"></div></div></div>');
  $('.footerWrapperInner').prepend(` <div class="breadcrumb">
      <ul class="breadcrumbInner">
        <li><a href="/">Home</a></li>
        <li>></li>
        <li>Cart</li> 
      </ul>
</div>`);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
    let len =  $('.cart-items tbody tr').length;
    $('span.itemCount').text(len);
    if(len == 0){
      $('.footerWrapperInner').css('grid-template-columns', '1fr')
    }
  $('body').on('click', 'cart-remove-button', function(){
     len = len-1;
      $('span.itemCount').text(len);
    if(len == 0){
      $('.footerWrapperInner').css('grid-template-columns', '1fr')
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
   /*collection grid list view */
     $(document).ready(function(){
      $(".grid-view-button").find("i").addClass("current");
      $("#product-grid").addClass("grid-view-filter");
      $("#product-grid").removeClass("list-view-filter");
    });
    $("body").on("click", ".list-view-button", function(){
      $(this).find("i").addClass("current");
      $(".grid-view-button").find("i").removeClass("current");
      $("#product-grid").removeClass("grid-view-filter");
      $("#product-grid").addClass("list-view-filter");
    });
    $("body").on("click", ".grid-view-button", function(){
      $(this).find("i").addClass("current");
      $(".list-view-button").find("i").removeClass("current");
      $("#product-grid").addClass("grid-view-filter");
      $("#product-grid").removeClass("list-view-filter");
    });
    /*collection load more */
      $(document).ready(function(){
        let proCount = $('#product-grid .grid__item').length;
         function dCount(proCount){
            $('.dynamicCount').text(proCount);
          }
        
        $('body').on('click', '.loadMore', function(e){
         e.preventDefault();
          let productsOnPage = $('#product-grid');
          let prodCount = $(this).attr('data-prod');
          let nextUrl = productsOnPage.attr('data-next-url');
           $.ajax({
             url: nextUrl,
             type: "GET",
             dataType: "html",
             success: function(nextPage){
               let newProducts = $(nextPage).find('#product-grid');
               //console.log(newProducts.html());
               productsOnPage.append(newProducts.html());
               let newUrl = newProducts.attr('data-next-url');
               nextUrl = newUrl
               productsOnPage.attr('data-next-url', nextUrl);
               
               var newproCount = $('#product-grid .grid__item').length;
               // let collectionItemL = '{{ collection.all_products_count }}';
  
               dCount(newproCount);

                function updatedata(option_value){
                  var productGrid = document.getElementById('product-grid');
                  var products = Array.from(productGrid.getElementsByClassName('grid__item'));
                  var attribute = option_value.includes('capacity') ? 'data-meta-capacity' : 'data-meta-psi';
                  var isAscending = option_value.includes('asc');
                  productGrid.innerHTML = '';
                 
                  $(products).sort(function(a, b) {
                    if(isAscending){
                      return $(a).attr(attribute) - $(b).attr(attribute);
                    }else{
                      return $(b).attr(attribute) - $(a).attr(attribute);
                    }
                  }).appendTo(productGrid);
  
                   
                }
               
               setTimeout(function(){
                 var sorValue = $('#SortBy :selected').val();
                 //console.log("sorValue "+sorValue);
                 updatedata(sorValue);
               }, 1000)
               
               if(newproCount >= prodCount){
                 $('.loadMore').hide();
               }
             }
           })
        
        })
      });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form =
      document.querySelector('#product-form-template--27509551661353__main') ||
      document.querySelector('form[action*="/cart/add"]');
    const modal = document.getElementById('delivery-options-modal');
    const closeButton = document.getElementById('delivery-modal-close');
    const updateButton = document.getElementById('delivery-modal-update');
    const liftgateSelect = document.getElementById('modal-liftgate');
    const residentialSelect = document.getElementById('modal-residential');

    if (!form || !modal) {
      console.log('Delivery modal: product form or modal not found');
      return;
    }

    const liftgateInput = form.querySelector('.tmsliftgate-option');
    const residentialInput = form.querySelector('.tmsaddresidential-option');

    /*
     * Flag controls intercept vs allow
     */
    let allowAddToCart = false;

    /* =======================================
     * OPEN POPUP
     * ======================================= */
    function openDeliveryModal() {
      if (liftgateInput && liftgateInput.value) {
        const currentLiftgate = liftgateInput.value.trim();
        if (currentLiftgate === 'Yes' || currentLiftgate === 'No') {
          liftgateSelect.value = currentLiftgate;
        }
      }

      if (residentialInput && residentialInput.value) {
        const currentResidential = residentialInput.value.trim();
        if (currentResidential === 'Residential Delivery' || currentResidential === 'Commercial Delivery') {
          residentialSelect.value = currentResidential;
        }
      }

      modal.classList.add('is-open');
      document.body.classList.add('delivery-options-open');
      modal.scrollTop = 0;
    }

    /* =======================================
     * CLOSE POPUP
     * ======================================= */
    function closeDeliveryModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('delivery-options-open');
    }

    /* =======================================
     * INTERCEPT ADD TO CART CLICK
     * ======================================= */
    const submitBtn = form.querySelector('[type="submit"]');

    if (submitBtn) {
      submitBtn.addEventListener(
        'click',
        function (event) {
          if (allowAddToCart) {
            return; // Let Dawn's AJAX process normally this one time
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation(); // Block Dawn AJAX from firing prematurely

          openDeliveryModal();
        },
        true
      );
    }

    form.addEventListener(
      'submit',
      function (event) {
        if (allowAddToCart) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openDeliveryModal();
      },
      true
    );

    /* =======================================
     * UPDATE BUTTON (AJAX ADD TO CART)
     * ======================================= */
    updateButton.addEventListener('click', function () {
      // 1. Update values in hidden form inputs
      if (liftgateInput) {
        liftgateInput.value = liftgateSelect.value;
      }
      if (residentialInput) {
        residentialInput.value = residentialSelect.value;
      }

      // 2. Close modal
      closeDeliveryModal();

      // 3. Set flag to allow this single add-to-cart submit
      allowAddToCart = true;

      // 4. Trigger Dawn's AJAX submission
      const productFormElement = form.closest('product-form');

      if (productFormElement && typeof productFormElement.onSubmitHandler === 'function') {
        const dummyEvent = new Event('submit', { cancelable: true, bubbles: true });

        // Execute Dawn's handler
        productFormElement.onSubmitHandler(dummyEvent);

        // RESET FLAG immediately in next event loop tick so the next click opens modal again!
        setTimeout(() => {
          allowAddToCart = false;
        }, 500);
      } else {
        // Fallback: fetch AJAX directly if product-form wrapper isn't present
        const formData = new FormData(form);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            // RESET FLAG so next click triggers modal again
            allowAddToCart = false;

            // Refresh cart drawer / section
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            allowAddToCart = false;
          });
      }
    });

    /* =======================================
     * CLOSE HANDLERS
     * ======================================= */
    closeButton.addEventListener('click', closeDeliveryModal);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeDeliveryModal();
      }
    });
  });

  $('.view-details-btn.openModalBtn').on('click', function () {
    $('#myModal').show();
    var conrader_kit = $(this).attr('conrader-kit');
    var samuel_kit = $(this).attr('samuel-kit');
    var safety_valve_model_kit = $(this).attr('safety-valve-model-kit');
    var end_connections_kit = $(this).attr('end-connections-kit');
    var valve_set_pressure_kit = $(this).attr('valve-set-pressure-kit');
    var valve_capacity_kit = $(this).attr('valve-capacity-kit');
    var gauge_pn_kit = $(this).attr('gauge-pn-kit');

    //console.log(conrader_kit);
    $('.table-wrapper').html(
      '<table><thead><tr class="table-head"><th>Conrader Kit No.</th><th>Samuel Kit No.</th><th>Safety Valve Model</th><th>End Connections</th><th>Valve Set Pressure (psi)</th><th>Valve Capacity</th><th>Gauge PN</th></tr></thead><tbody><tr><td>' +
        conrader_kit +
        '</td><td>' +
        samuel_kit +
        '</td><td>' +
        safety_valve_model_kit +
        '</td><td>' +
        end_connections_kit +
        '</td><td>' +
        valve_set_pressure_kit +
        '</td><td>' +
        valve_capacity_kit +
        '</td><td>' +
        gauge_pn_kit +
        '</td></tr></tbody></table>'
    );
  });

  $('.view-details-btn.openDrainModalBtn').on('click', function () {
    $('#myModal').show();
    var conrader_kit = $(this).attr('conrader-kit');
    var gauge_pn_kit = $(this).attr('gauge-pn-kit');
    var valve_capacity_kit = $(this).attr('valve-capacity-kit');
    var valve_set_pressure_kit = $(this).attr('valve-set-pressure-kit');
    var end_connections_kit = $(this).attr('end-connections-kit');
    var safety_valve_model_kit = $(this).attr('safety-valve-model-kit');
    var samuel_kit = $(this).attr('samuel-kit');
    var drain_valves_a_length = $(this).attr('drain-valves-a-length');
    var drain_valves_weight_lbs = $(this).attr('drain-valves-weight-lbs');

    //console.log(conrader_kit);
    $('.table-wrapper').html(
      '<table><thead><tr class="table-head"><th>Conrader Part #</th><th>Samuel Part #</th><th>Inlet</th><th>Outlet</th><th>Orifice</th><th>Voltage</th><th>Coil</th></th><th>“A” Length</th><th>Weight (lbs)</th></tr></thead><tbody><tr><td>' +
        conrader_kit +
        '</td><td>' +
        gauge_pn_kit +
        '</td><td>' +
        valve_capacity_kit +
        '</td><td>' +
        valve_set_pressure_kit +
        '</td><td>' +
        end_connections_kit +
        '</td><td>' +
        safety_valve_model_kit +
        '</td><td>' +
        samuel_kit +
        '</td><td>' +
        drain_valves_a_length +
        '</td><td>' +
        drain_valves_weight_lbs +
        '</td></tr></tbody></table>'
    );
  });

  $('#fullSystem').on('click', function () {
    $('#customSupport').show();
  });
  $('.close-btn').on('click', function () {
    $('#myModal').hide();
    $('#customSupport').hide();
  });
  $(document).ready(function () {
    //$("#tab2 .custom-interior").hide();
    // Show the first tab and hide the rest
    var currentVprice = cVariantP;
    var currentVarMetaVal1 = currentVarMetaVal;
    console.log('currentVarMetaVal ' + currentVarMetaVal1);
    var currval = cuvl;
    var currval1 = cuvl1;
    var currval2 = cuvl2;
    console.log('currval ' + currval);
    console.log('currval1 ' + currval1);
    console.log('currval2 ' + currval2);
    $('#tab2 .custom-interior').hide();
    //exteriorColorBox
    // if(currval.indexOf('Custom') != -1 || currentVprice == 9999900){
    // if(currentVprice == 9999900){
    if (currentVarMetaVal1 == 'true') {
      $('.custom-btn-product .wrapButton').addClass('disabled');
      $('.custom-btn-product .wrapButton .product-form__submit').addClass('disabled');
      $('.custom-btn-product .wrapButton .product-form__submit').prop('disabled', true);
    }
    if (currval.indexOf('Custom') != -1) {
      $('#tab1Color .exteriorColorBox').show();
    } else {
      $('#tab1Color .exteriorColorBox').hide();
    }

    if (currval1.indexOf('Standard primer') != -1 && currval2.indexOf('Unpainted') != -1) {
      $('#tab2 .custom-interior').hide();
    }
    if (currval1.indexOf('Standard primer') != -1) {
      $('#tab1Color .White').hide();
      $('#tab1Color .Black').hide();
      $('#tab1Color .Blue').hide();
      $('#tab1Color .Custom').hide();
    }
    if (currval1.indexOf('Standard primer') != -1 && currval2.indexOf('FDA or NSF') != -1) {
      $('#tab2 .custom-interior').hide();
    }
    if (currval1.indexOf('Standard primer') != -1 && currval2.indexOf('Epoxy') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Standard primer') != -1 && currval2.indexOf('Galvanize') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Standard primer') != -1 && currval2.indexOf('Powder') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').show();
      $('#tab2 .InteriorBlack').show();
      $('#tab2 .InteriorBlue').show();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Powder') != -1 && currval2.indexOf('Unpainted') != -1) {
      $('#tab2 .custom-interior').hide();
    }
    if (currval1.indexOf('Powder') != -1 && currval2.indexOf('FDA or NSF') != -1) {
      $('#tab2 .custom-interior').hide();
    }
    if (currval1.indexOf('Powder') != -1 && currval2.indexOf('Powder') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').show();
      $('#tab2 .InteriorBlack').show();
      $('#tab2 .InteriorBlue').show();
      $('#tab2 .InteriorCustom').hide();
      $('#tab1Color .Custom').hide();
    }
    if (currval1.indexOf('Powder') != -1 && currval2.indexOf('Epoxy') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
      $('#tab1Color .Custom').hide();
    }
    if (currval1.indexOf('Powder') != -1 && currval2.indexOf('Galvanize') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
      $('#tab1Color .Custom').hide();
    }
    if (currval1.indexOf('Enamel') != -1 && currval2.indexOf('Powder') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').show();
      $('#tab2 .InteriorBlack').show();
      $('#tab2 .InteriorBlue').show();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Enamel') != -1 && currval2.indexOf('Epoxy') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Enamel') != -1 && currval2.indexOf('Galvanize') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Galvanize') != -1 && currval2.indexOf('Powder') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').show();
      $('#tab2 .InteriorBlack').show();
      $('#tab2 .InteriorBlue').show();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Galvanize') != -1 && currval2.indexOf('Epoxy') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval1.indexOf('Galvanize') != -1 && currval2.indexOf('Galvanize') != -1) {
      $('#tab2 .custom-interior').show();
      $('#tab2 .InteriorGray input:radio').trigger('click');
      $('#tab2 .InteriorWhite').hide();
      $('#tab2 .InteriorBlack').hide();
      $('#tab2 .InteriorBlue').hide();
      $('#tab2 .InteriorCustom').hide();
    }
    if (currval2.indexOf('FDA or NSF') != -1 || currval2.indexOf('Unpainted') != -1) {
      $('#tab2 .custom-interior').hide();
      $('.requestQuote-InteriorColor').val('');
      $('#summaryInterior .colorSummary').hide();
    } else {
      $('#summaryInterior .colorSummary').show();
    }

    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

    // Click function
    $('#tabs-nav li').click(function () {
      // if($(this).hasClass('exteriorCls') || $(this).hasClass('interiorCls')){
      if ($(this).hasClass('exteriorCls')) {
        $('#tabs-content #tab1Color').show();
      } else {
        $('#tabs-content #tab1Color').hide();
      }

      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();

      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });
    $('.colors span').click(function () {
      $('.colors span').removeClass('active');
      $(this).addClass('active');
    });

    $('.add-to-cart-btn').click(function (e) {
      e.preventDefault();
      let button = $(this);
      button.text('Adding...');
      let variantID = $(this).data('product-variant');
      let quantity = 1;
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: variantID,
        },
        dataType: 'json',
        success: function (response) {
          //console.log(response);
          // Update cart count
          fetch(window.Shopify.routes.root + 'cart.js')
            .then((response) => response.json())
            .then((data) => {
              $('.cart-count-bubble span').text(data.item_count);
              //console.log(data);
            });
          button.text('Add to Cart');
        },
        error: function (xhr, status, error) {
          console.error(xhr.responseText);
          button.text('Add to Cart');
        },
      });
    });

    // New function to track Request Quote button click - PASTE HERE
    $('.request-quote-btn').click(function (e) {
      e.preventDefault();

      if (typeof gtag !== 'undefined') {
        gtag('event', 'request_quote_click', {
          event_category: 'engagement',
          event_label: 'Vessel Quote Request',
          value: 1,
          transport_type: 'beacon',
        });
      }
    });

    // setTimeout( function() {
    //    $(".product-form__quote span").text("Request A Quote");
    // }, 1000)
    jQuery('#tab1Color fieldset .Gray label').text('Gray (RAL 7011)');
    jQuery('#tab1Color fieldset .Blue label').text('Blue (RAL 5015)');

    $('#customColorBox').keypress(function () {
      var dInput = $(this).val();
      //console.log(dInput);
      $('.requestQuote-ExteriorCustomColor').val(dInput);
      //$(".dDimension:contains('" + dInput + "')").css("display","block");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specification"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    // Show the first tab and hide the rest
      $('#tabs-navs li:first-child').addClass('active');
      $('.tab-contents').hide();
      $('.tab-contents:first').show();
  
      // Click function
      $('#tabs-navs li').click(function(){
        $('#tabs-navs li').removeClass('active');
        $(this).addClass('active');
        $('.tab-contents').hide();
        
        var activeTabs = $(this).find('a').attr('href');
        $(activeTabs).fadeIn();
        return false;
      });
  });
  $(".mob-tab-radio").on("click", function () {           
    if ($(this).data("selected") === true) {
      $(this).data("selected", false);
      $(this).prop("checked", false);
    } else {
      $(this).data("selected", true);
      $(this).prop("checked", true);
    }
    //Then be sure to set that for ALL tabs.
    $(".mob-tab-radio").each(function () {
      $(this).data("selected", $(this).prop("checked"));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
